import React from "react";

export default function ProductListSearchBar({
  value,
  onChange,
  onSearch,
  placeholder = "Search products",
}) {
  return (
    <div className="flex w-full min-w-0 items-center gap-2 lg:max-w-md lg:shrink-0">
      <div className="flex min-w-0 flex-1 items-center gap-2 rounded-full border border-[#E6EAF0] bg-white/70 px-3 py-2 shadow-sm">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSearch();
          }}
          placeholder={placeholder}
          className="min-w-0 w-full bg-transparent text-[15px] font-medium text-[#24303A] placeholder:text-[15px] placeholder:text-[#6E7B86] focus:outline-none sm:text-base"
        />
        <button
          type="button"
          onClick={onSearch}
          className="hidden shrink-0 items-center justify-center rounded-full bg-[#7352C7] px-3 py-1 text-[14px] font-semibold text-white shadow-sm xl:inline-flex"
          aria-label="Search"
        >
          Search
        </button>
      </div>
      <button
        type="button"
        onClick={onSearch}
        className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#7352C7] text-white shadow-sm xl:hidden"
        aria-label="Search"
      >
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M21 21l-4.35-4.35" />
          <circle cx="11" cy="11" r="7" />
        </svg>
      </button>
    </div>
  );
}
